// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1-Nim","buttons":"SendReceipts_buttons__1Qvma","email":"SendReceipts_email__3EZnH","bookApptTitle":"SendReceipts_bookApptTitle__17iUn"};